import { render, staticRenderFns } from "./CurrentAlarmCount.vue?vue&type=template&id=0a5ab98a&"
import script from "./CurrentAlarmCount.vue?vue&type=script&lang=js&"
export * from "./CurrentAlarmCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports